module.exports = __webpack_public_path__ + "img/Tomek_Smolka.45241625.jpg";